import React from "react";
import { useUsuario } from "../Hooks/UsuarioHook";
import { AppRoutes } from "./app.routes";
import { AuthRoutes } from "./auth.routes";

export const Routes = () => {

  const{usuario,} = useUsuario();

  return usuario.usuario && usuario.usuario.id ?  <AppRoutes />:<AuthRoutes /> ;
};
